import { render, staticRenderFns } from "./description.vue?vue&type=template&id=6d914672&scoped=true"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"
import style0 from "./description.vue?vue&type=style&index=0&id=6d914672&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d914672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d914672')) {
      api.createRecord('6d914672', component.options)
    } else {
      api.reload('6d914672', component.options)
    }
    module.hot.accept("./description.vue?vue&type=template&id=6d914672&scoped=true", function () {
      api.rerender('6d914672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/level/description.vue"
export default component.exports